// src/components/Dashboard.js

import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Toast, ToastContainer } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectTokens, selectAppRoles } from '../redux/userSlice';
import MessageComponent from './MessageComponent';
import AppPortal from './AppPortal';
import './Dashboard.css'; // Import the updated file
import SendMessageComponent from './SendMessageComponent';
import EmailComponent from './EmailComponent';
import DocumentManager from './DocumentManager/DocumentManager';
import UserManagementComponent from './UserManagementComponent';
import UploadDocumentComponent from './DocumentManager/UploadDocumentComponent';
import SaleRegistrationsComponent from './SaleRegistrationsComponent';
import UserNotes from './UserNotes';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

import { 
  FaBell, 
  FaPaperPlane, 
  FaUsers, 
  FaFileUpload, 
  FaFolderOpen, 
  FaClipboardList, 
  FaChartLine 
} from 'react-icons/fa';

const Dashboard = () => {
  useDocumentTitle("Dashboard");
  const [showToast, setShowToast] = useState(false)
  const [toastInfo, setToastInfo] = useState({
    header: "",
    body: "",
    variant: ""
  })
  // const [toastHeader, setToastHeader] = useState(false)
  // const [toastBody, setToastBody] = useState(false)
  const tokens = useSelector(selectTokens);
  const appRoles = useSelector(selectAppRoles);
  const navigate = useNavigate();

  // When tokens are cleared (logged out), navigate to the home page.
  useEffect(() => {
    if (!tokens.accessToken) {
      navigate('/');
    }
  }, [tokens.accessToken, navigate]);

  // Updated to handle both uppercase and lowercase role keys.
  const hasPortalAdminAccess = 
    appRoles?.PORTAL === 'Portal Admin' || 
    appRoles?.portal === 'Portal Admin';


  return (
    <div className="my-dashboard-container">
      <h1 className="visually-hidden">Dashboard</h1>
       {/* On Success Toast Notification */}
        <ToastContainer
          position="top-end"
          className="p-3 unique-auction-toast-container"
          aria-live="polite"
        >
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={8000}
            autohide
            bg={toastInfo.variant}
          >
            <Toast.Header>
              <strong className="me-auto">{toastInfo.header}</strong>
            </Toast.Header>
            <Toast.Body>
              <div style={{ marginBottom: "10px" }}>
                {toastInfo.body}
              </div>
            </Toast.Body>
          </Toast>
        </ToastContainer>
      <div className="my-dashboard-item">
        <MessageComponent />
      </div>
      <div className="my-dashboard-item">
        <AppPortal tokens={tokens} />
      </div>

      {hasPortalAdminAccess && (
        <div className="my-dashboard-control-center">
          <Tabs mountOnEnter defaultActiveKey="sendMessage" id="dashboard-tabs" justify aria-label="Admin tools">
            <Tab eventKey="sendMessage" title={<><FaBell aria-hidden="true" /> <span>Send Notification</span></>}>
              <SendMessageComponent />
            </Tab>
            <Tab eventKey="sendEmail" title={<><FaPaperPlane aria-hidden="true" /> <span>Send Email</span></>}>
              <EmailComponent />
            </Tab>
            <Tab eventKey="manageDocuments" title={<><FaFolderOpen aria-hidden="true" /> <span>Manage Documents</span></>}>
              <DocumentManager setToastInfo={setToastInfo} setShowToast={setShowToast}/>
            </Tab>
            <Tab eventKey="manageUsers" title={<><FaUsers aria-hidden="true" /> <span>Manage Users</span></>}>
              <UserManagementComponent setToastInfo={setToastInfo} setShowToast={setShowToast}/>
            </Tab>
            <Tab eventKey="uploadDocument" title={<><FaFileUpload aria-hidden="true" /> <span>Upload Document</span></>}>
              <UploadDocumentComponent />
            </Tab>
            <Tab eventKey="manageRegistrations" title={<><FaClipboardList aria-hidden="true" /> <span>Manage Registrations</span></>}>
              <SaleRegistrationsComponent />
            </Tab>
            <Tab eventKey="viewInsights" title={<><FaChartLine aria-hidden="true" /> <span>View Insights</span></>}>
              <UserNotes />
            </Tab>
          </Tabs>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
